import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-approve-dialog',
  templateUrl: './approve-dialog.component.html',
  styleUrls: ['./approve-dialog.component.scss']
})
export class ApproveDialogComponent {
  title: string;
  text: string;

  constructor(
    protected dialogRef: MatDialogRef<ApproveDialogComponent>,
    @Inject(MAT_DIALOG_DATA) protected data
  ) {
    this.title = data.title;
    this.text = data.text;
  }

  cancel() {
    this.dialogRef.close(false);
  }

  approve() {
    this.dialogRef.close(true);
  }
}
